var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRblBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_20803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64435 3.86671V8.96454e-05H1.6001V9.14496C1.6001 6.89379 2.82591 4.91825 4.64435 3.86671Z",
    fill: "#21317D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07428 3.06179V6.12012C9.57797 6.30734 10.7444 7.58861 10.7444 9.14129C10.7444 10.8297 9.38118 12.1937 7.69477 12.1937C6.01372 12.1937 4.64742 10.8297 4.64742 9.14129H4.64404V14.4229C5.54243 14.9407 6.58467 15.2436 7.69477 15.2436C11.0617 15.2436 13.79 12.5147 13.79 9.14495C13.79 5.90784 11.2641 3.25633 8.07428 3.06179Z",
    fill: "#21317D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64435 3.86656C2.82591 4.9181 1.6001 6.89364 1.6001 9.14481V14.7786V15.9999H4.64435V15.2015V14.4225V9.14115H4.64773C4.64773 7.58847 5.81076 6.30748 7.31501 6.11998V3.06165C6.34624 3.11936 5.43603 3.40625 4.64435 3.86656Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_20803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRblBank);
export default __webpack_public_path__ + "static/media/rbl-bank.540e24820df86feb36bb777f4370901d.svg";
export { ForwardRef as ReactComponent };